import Request from '@Core/xhr'
import to from '@Utils/to'
import qs from 'qs'
import SmoothScroll from 'smooth-scroll'

const scroll = new SmoothScroll()

export default ({ lists, pagination }) => {
  let search = location.search.length
    ? qs.parse(location.search.replace('?', ''))
    : {
      page: 1,
      sort: null,
      limit: 48,
      query: null,
      color: [],
      motive: [],
      brand: [],
      width: [],
      material: [],
      property: []
    }

  let selected = {
    color: search.color
      ? search.color.map(cid => lists.color.find(item => item.id === parseInt(cid)))
      : [],
    motive: search.motive
      ? search.motive.map(cid => lists.motive.find(item => item.id === parseInt(cid)))
      : [],
    brand: search.brand
      ? search.brand.map(cid => lists.brand.find(item => item.id === parseInt(cid)))
      : [],
    width: search.width
      ? search.width.map(cid => lists.width.find(item => item.id === parseInt(cid)))
      : [],
    material: search.material
      ? search.material.map(cid => lists.material.find(item => item.id === parseInt(cid)))
      : [],
    property: search.property
      ? search.property.map(cid => lists.property.find(item => item.id === parseInt(cid)))
      : []
  }

  return {

    namespaced: true,

    state: {
      selected,
      pagination,
      loading: false,
      page: search.page,
      sort: search.sort,
      limit: isNaN(parseInt(search.limit)) ? 48 : parseInt(search.limit),
      query: search.query,
      lists: lists || {
        color: [],
        motive: [],
        brand: [],
        width: [],
        material: [],
        property: []
      }
    },

    // mutating the state
    // mutations are always synchronous
    mutations: {

      pagination (state, { pagination }) {
        state.pagination = pagination
        state.loading = false
      },

      page (state, { page }) {
        state.page = page
        state.loading = true
      },

      select (state, { item, type }) {
        state.selected[type] = [...state.selected[type], item]
      },

      deselect (state, { item, type }) {
        state.selected[type] = [...state.selected[type]].filter(e => e.title !== item.title)
      },

      sort (state, { sort }) {
        state.sort = sort
      },

      limit (state, { limit }) {
        state.limit = limit
      }

    },

    // commits the mutation, it's asynchronous
    // use actions for performing server requests without blocking
    // application while waiting for the response
    actions: {

      paginate ({ commit, dispatch }, { page }) {
        commit('page', { page })
        dispatch('refresh')
      },

      select ({ commit, dispatch }, { item, type }) {
        commit('select', { item, type })
        commit('page', { page: 1 })
        dispatch('refresh')
      },

      deselect ({ commit, dispatch }, { item, type }) {
        commit('deselect', { item, type })
        commit('page', { page: 1 })
        dispatch('refresh')
      },

      sorting ({ commit, dispatch }, { sort }) {
        commit('sort', { sort })
        commit('page', { page: 1 })
        dispatch('refresh')
      },

      setLimit ({ commit, dispatch }, { limit }) {
        commit('limit', { limit })
        commit('page', { page: 1 })
        dispatch('refresh')
      },

      async refresh ({ commit, getters }) {
        let request = new Request(getters.search)
        let [, pagination] = await to(request.post(getters.path))
        pagination && commit('pagination', { pagination })

        let path = getters.path + getters.qs
        window.history.replaceState({ path }, '', path)

        scroll.animateScroll(
          document.querySelector('#filters'),
          null,
          {
            offset: anchor => 125,
            speed: 300
          }
        )
      }

    },

    // showing things, not mutating state
    getters: {

      /**
       * Generates query string from selected filters and updates location
       */
      qs: (state, getters) => {
        return qs.stringify(
          { ...getters.search },
          {
            arrayFormat: 'brackets',
            encodeValuesOnly: true,
            addQueryPrefix: true
          }
        )
      },

      /**
       * Current url location without query string
       */
      path: (state, getters) => {
        let {
          protocol,
          host,
          pathname
        } = window.location

        return protocol + '//' + host + pathname
      },

      /**
       * Parsed array for server side filtering
       */
      search: state => {
        return {
          page: state.page,
          sort: state.sort,
          limit: state.limit === 48 ? null : state.limit,
          query: state.query,
          color: state.selected.color.map(item => item.id),
          motive: state.selected.motive.map(item => item.id),
          brand: state.selected.brand.map(item => item.id),
          width: state.selected.width.map(item => item.id),
          material: state.selected.material.map(item => item.id),
          property: state.selected.property.map(item => item.id)
        }
      },

      /**
       * All active list filters
       */
      active: state => state.selected.color.map(item => { item.type = 'color'; return item })
        .concat(state.selected.motive.map(item => { item.type = 'motive'; return item }))
        .concat(state.selected.brand.map(item => { item.type = 'brand'; return item }))
        .concat(state.selected.width.map(item => { item.type = 'width'; return item }))
        .concat(state.selected.material.map(item => { item.type = 'material'; return item }))
        .concat(state.selected.property.map(item => { item.type = 'property'; return item })),

      /**
       * Random ad position if present.
       */
      adPosition: ({ pagination }) =>
        pagination && pagination.advert && pagination.items
          ? Math.floor(Math.random() * (pagination.items.length - 4)) + 4
          : 999
    }

  }
}
